/**
 * <LiveEngagementScoreList> — the three engagement axes + bar (molecule, L0.1).
 *
 * Renders Présence / Participation / Productivité as `<LiveEngagementScore>` rows, then a
 * `<SegmentedBar>` of the three axis values over 100. Pure composition over the score axes —
 * no hex.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { SegmentedBar } from "../../atoms/SegmentedBar"
import { LiveEngagementScore } from "../LiveEngagementScore"
import { engagementScores } from "../../../ports/primary/ui/formatters/liveSessionReportFormatter"
import { type UILiveSessionReportDetails } from "../../../ports/primary/ui/types"

export type LiveEngagementScoreListProps = {
    scores: NonNullable<UILiveSessionReportDetails["scores"]>
    testID?: string
}

export function LiveEngagementScoreList(props: LiveEngagementScoreListProps) {
    const { scores, testID } = props
    const axes = engagementScores(scores)

    return (
        <Stack gap="3" testID={testID}>
            {axes.map((axis) => (
                <LiveEngagementScore key={axis.label} {...axis} />
            ))}
            <SegmentedBar max={100} segments={axes.map((axis) => ({ value: axis.value, color: axis.color }))} />
        </Stack>
    )
}
